import { render, staticRenderFns } from "./resultatAnalyse.vue?vue&type=template&id=33c2a088&scoped=true"
import script from "./resultatAnalyse.vue?vue&type=script&lang=js"
export * from "./resultatAnalyse.vue?vue&type=script&lang=js"
import style0 from "./resultatAnalyse.vue?vue&type=style&index=0&id=33c2a088&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33c2a088",
  null
  
)

export default component.exports